import DefaultLayout from '##/Default';
import List from './List';
import Help from './Help';

const routes = [
    {
        path: '/documents',
        exact: true,
        layout: DefaultLayout,
        component: List,
        auth: true,
        title: 'View Documents'
    },
    {
        path: '/documents/help',
        exact: true,
        layout: DefaultLayout,
        component: Help,
        auth: true,
        title: 'View Template Aliases'
    }
];

export default routes;
